<template>
  <div class="role-page full-height">
    <table-con :showBreadCrumb='0'>
      <div slot="search">
        <el-collapse v-show="isActive">
          <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title">{{$t('mess.mess3')}}:</div>
            <div class="flex1">
              <el-input :placeholder="$t('mess.mess3')" clearable v-model="queryInfo.orderId" size="small"
                @keyup.enter.native="searchList">
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title" style="width:150px">{{$t('mess.mess4')}}:</div>
            <div class="flex1">
              <el-select v-model="queryInfo.messageType" :placeholder="$t('mess.mess4')" size="small" clearable>
                <el-option v-for="item in messageTypeOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">{{$t('mess.mess5')}}:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeStart" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" :placeholder="$t('mess.mess6')">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">{{$t('mess.mess7')}}:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeEnd" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" :placeholder="$t('mess.mess6')">
              </el-date-picker>
            </div>
          </el-col>
        </el-row>
        </el-collapse>
        <el-row class="search-row">
          <!-- <el-col :span="6" class="display-row">
            <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 0}"
              @click="quickSearchList('',index = 0)">{{$t('mess.mess8')}}</el-button>
            <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 1}"
              @click="quickSearchList('0',index = 1)">{{$t('mess.mess9')}}<span class="lx-red">({{orderData.unReadNum}})</span>
            </el-button>
            <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 2}"
              @click="quickSearchList('1',index = 2)">{{$t('mess.mess10')}}</el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 3}"
              @click="quickSearchList('1',index = 3)">{{$t('mess.mess50')}}</el-button>
          </el-col> -->
          <el-col :span="24" class="display-row">
            <div style="text-align:right;width:100%;padding-right:10px;floate:right">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">{{$t('mess.mess11')}}</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">{{$t('mess.mess12')}}</el-button>
              <el-button class="search-btn btn-blue" v-if="!isActive" type="primary" icon="el-icon-arrow-down" alt="" @click="isActive = !isActive" >{{$t('search.expandPanel')}}</el-button>
              <el-button class="search-btn btn-green" v-if="isActive" icon="el-icon-arrow-up" alt="" @click="isActive = !isActive" >{{$t('search.retractPanel')}}</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col" style="padding:10px">
        <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" :data="messageList" border
          height="550px">
          <el-table-column type="index" align="center" :label="$t('wzbg.wz6')" width="60"></el-table-column>
          <el-table-column :label="$t('handle')" align="center" width="70">
            <template v-slot="scope">
              <div class="btn-row">
                <el-button class="list-btn btn-blue" @click="handleDetail(scope.row)">
                  {{$t('detail')}}
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="isRead" sortable :index="indexMethod" align="center" width="100" :label="$t('mess.mess16')">
            <template v-slot="scope">
              <span v-if="scope.row.replyFlag==1">{{ replyStatusShow(scope.row.replyFlag) }}</span>
              <span v-else-if="scope.row.isRead==1">{{ readStatusShow(scope.row.isRead) }}</span>
              <span v-else>{{ readStatusShow(scope.row.isRead) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="replyPicture" align="center" width="100" :label="$t('mess.mess17')">
            <template slot-scope="scope">
              <div v-for="item in getFileList(scope.row.replyPicture)" :key="item">
                <img @click="imgclick(item,true)" v-if="item&&item.length>0"
                     :src="item" alt="" class="list-image more-image" >
                <img v-else src="../../assets/images/default.png" alt="" class="list-image">
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="messageType" width="100" :label="$t('mess.mess18')">
            <template v-slot="scope">
              {{ typeDetailShow(scope.row.messageType) }}
            </template>
          </el-table-column>
          <el-table-column prop="orderId" align="center" width="200" :label="$t('mess.mess19')">
            <template v-slot="scope">
              <el-link @click="toOrderDetail(scope.row)" :underline="false">{{scope.row.orderId}}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" sortable width="200" align="center" :index="indexMethod" :label="$t('mess.mess20')">
            <template v-slot="scope">
              {{ scope.row.createTime | dateFormatToSecond }}
            </template>
          </el-table-column>
          <el-table-column prop="remindingTitle" width="200" :label="$t('mess.mess21')">
          </el-table-column>
          <el-table-column prop="remindingContent" :label="$t('mess.mess22')">
            <template v-slot="scope">
              <div v-html="scope.row.remindingContent"></div>
            </template>
          </el-table-column>
          <el-table-column prop="fileName" :label="$t('mess.mess45')">
            <template v-slot="scope">
              <span v-for="item in getAttachment(scope.row.attachment)" :key="item">
                <a target="_blank" :href="item.url">{{item.name}}</a><br/>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]" :pager-count="5" :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </table-con>
    <!-- 详情 -->
    <el-dialog :title="$t('detail')" :visible.sync="detailFlag" width="1200px">
      <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" :data="firstList" border>
        <el-table-column prop="replyFlag" :index="indexMethod" align="center" width="70" :label="$t('mess.mess16')">
          <template v-slot="scope">
            <span v-if="scope.row.replyFlag==1">{{ replyStatusShow(scope.row.replyFlag) }}</span>
            <span v-else-if="scope.row.isRead==1">{{ readStatusShow(scope.row.isRead) }}</span>
            <span v-else>{{ readStatusShow(scope.row.isRead) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remindingTitle" width="200" :label="$t('mess.mess21')">
        </el-table-column>
        <el-table-column width="300" :label="$t('mess.mess22')">
          <template v-slot="scope">
            <div v-html="scope.row.remindingContent"></div>
          </template>
        </el-table-column>
        <el-table-column prop="replyPicture" align="center" :label="$t('mess.mess17')">
          <template slot-scope="scope">
            <div v-for="item in getFileList(scope.row.replyPicture)" :key="item">
              <img @click="imgclick(item,true)" v-if="item&&item.length>0"
                   :src="item" alt="" class="list-image more-image" >
              <img v-else src="../../assets/images/default.png" alt="" class="list-image">
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" :label="$t('mess.mess45')">
          <template v-slot="scope">
            <span v-for="item in getAttachment(scope.row.attachment)" :key="item">
              <a target="_blank" :href="item.url">{{item.name}}</a><br/>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="orderId" align="center" :label="$t('mess.mess19')">
          <template v-slot="scope">
            <el-link v-if="scope.row.messageType==1" @click="toOrderDetail(scope.row)" :underline="false">{{scope.row.orderId}}
            </el-link>
            <span v-else>{{scope.row.orderId}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" align="center" :index="indexMethod" :label="$t('mess.mess20')">
          <template v-slot="scope">
            {{ scope.row.createTime | dateFormatToSecond }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="messageType" :label="$t('mess.mess18')">
          <template v-slot="scope">
            {{ typeDetailShow(scope.row.messageType) }}
          </template>
        </el-table-column>
      </el-table>
      <div class="title">{{$t('mess.mess46')}}</div>
      <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" :data="historyMessageList" border
        height="550px">
        <el-table-column width="70" prop="sender" align="center" :label="$t('mess.mess47')">
          <template v-slot="scope">
            <span v-if="scope.row.sender==1">{{$t('mess.mess49')}}</span>
            <span v-if="scope.row.sender==0">{{$t('mess.mess48')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="replyFlag" :index="indexMethod" align="center" width="70" :label="$t('mess.mess16')">
          <template v-slot="scope">
            <span v-if="scope.row.replyFlag==1">{{ replyStatusShow(scope.row.replyFlag) }}</span>
            <span v-else-if="scope.row.isRead==1">{{ readStatusShow(scope.row.isRead) }}</span>
            <span v-else>{{ readStatusShow(scope.row.isRead) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remindingTitle" width="200" :label="$t('mess.mess21')">
        </el-table-column>
        <el-table-column width="300" :label="$t('mess.mess22')">
          <template v-slot="scope">
            <div v-html="scope.row.remindingContent"></div>
          </template>
        </el-table-column>
        <el-table-column prop="replyPicture" align="center" :label="$t('mess.mess17')">
          <template slot-scope="scope">
            <div v-for="item in getFileList(scope.row.replyPicture)" :key="item">
              <img @click="imgclick(item,true)" v-if="item&&item.length>0"
                   :src="item" alt="" class="list-image more-image" >
              <img v-else src="../../assets/images/default.png" alt="" class="list-image">
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" :label="$t('mess.mess45')">
          <template v-slot="scope">
            <span v-for="item in getAttachment(scope.row.attachment)" :key="item">
              <a target="_blank" :href="item.url">{{item.name}}</a><br/>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="orderId" align="center" :label="$t('mess.mess19')">
          <template v-slot="scope">
            <el-link v-if="scope.row.messageType==1" @click="toOrderDetail(scope.row)" :underline="false">{{scope.row.orderId}}
            </el-link>
            <span v-else>{{scope.row.orderId}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" align="center" width="90" :index="indexMethod" :label="$t('mess.mess20')">
          <template v-slot="scope">
            {{ scope.row.createTime | dateFormatToSecond }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="messageType" :label="$t('mess.mess18')">
          <template v-slot="scope">
            {{ typeDetailShow(scope.row.messageType) }}
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align:right;margin-top:15px">
        <el-button class="form-btn btn-blue" @click="detailFlag=false">{{$t('confirm')}}</el-button>
      </div>
    </el-dialog>
    <!--    图片放大-->
    <el-dialog title="" :visible.sync="visible" width="30%" show-close center>
      <img width="100%" height="auto" :src="imgurl" alt="" class="list-image">
      <!--    <img :src="this.$store.state.imgurl" alt="">-->
    </el-dialog>
  </div>
</template>

<script>
import tableCon from '../../views/tableContainer'

export default {
  components: { tableCon },
  data () {
    return {
      isActive:false,
      curIndex: 0, // 默认选中第0个
      visible: false,
      imgurl: '',
      queryInfo: {
        remindingUserName: '',
        orderId: '',
        messageType: '',
        createTimeStart: '',
        createTimeEnd: '',
        isRead: '',
        replyFlag: '',
        pageSize: 10,
        pageNum: 1
      },
      orderData: {
        unReadNum: 0,
      },
      detailFlag: false,
      firstList: [],
      historyMessageList: [],
      statusFlag: '',
      dateRangeValue: [],
      messageTypeOptions: [
        {
          value: '1',
          label: this.$t('mess.mess31')
        }, {
          value: '2',
          label: this.$t('mess.mess32')
        }
      ],
      replyStatusOptions: [
        {
          value: '',
          label: this.$t('mess.mess33')
        },
        {
          value: '0',
          label: this.$t('mess.mess9')
        }, {
          value: '10',
          label: this.$t('mess.mess10')
        }, {
          value: '100',
          label: this.$t('mess.mess34')
        }
      ],
      messageList: [],
      total: 0,
    }
  },
  methods: {
    getFileList (str) {
      if (str != null){
        return str.split(",");
      }
      return []
    },
    getAttachment (str){
      if (str != null && str.length > 0){
        return JSON.parse(str);
      }
      return []
    },
    imgclick (url, visible) {
      this.visible = true
      this.imgurl = url
      console.log(this.imgurl)
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.getMessageList();
    },
    async handleDetail (row) {
       this.id = row.id
      const { data: res } = await this.$http.get('cmUser/message/queryMessageInfo/' + row.id);
      this.historyMessageList = res.data
      let arr = []
      res.data.forEach(item => {
        if (item.id == this.id) {
          arr.push(item)
        }
      })
      this.firstList = arr
      this.detailFlag = true
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getMessageList();
    },
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    orderDateRange () {   //搜索时间

    },
    searchList () {    //查询
      this.queryInfo.pageNum = 1;
      this.queryInfo.isRead = '';
      this.queryInfo.replyFlag = '';
      if (this.statusFlag == '0') {
        this.queryInfo.isRead = '0';
      } else if (this.statusFlag == 10) {
        this.queryInfo.isRead = '1';
      } else if (this.statusFlag == 100) {
        this.queryInfo.replyFlag = '1';
      }
      this.getMessageList();
      this.getStatisticalNum();
    },
    quickSearchList (val, index) {
      this.curIndex = index
      this.queryInfo.pageNum = 1;
      if (index == 3) {
        this.queryInfo.replyFlag = val;
        this.queryInfo.isRead = '';
      } else {
        this.queryInfo.isRead = val;
        this.queryInfo.replyFlag = '';
      }
      this.getMessageList();
      this.getStatisticalNum();
    },
    async getMessageList () {   //获取信息列表
      console.log(this.queryInfo);
      const { data: res } = await this.$http.get('cmUser/message/outList', { params: this.queryInfo });
      console.log(res);
      this.messageList = res.data.list;
      this.total = res.data.total;
    },
    async getStatisticalNum () {      //获取
      const { data: res } = await this.$http.get("cmUser/message/getOutStatisticalNum", { params: this.queryInfo });
      this.orderData = res.data;
    },
    queryInfoClear () {    //清空
      this.queryInfo = {
        remindingUserName: '',
        orderId: '',
        messageType: '',
        createTimeStart: '',
        createTimeEnd: '',
        isRead: '',
        replyFlag: '',
        pageSize: 10,
        pageNum: 1
      }
      this.statusFlag = '';
      this.dateRangeValue = [];
    },
    typeDetailShow (status) {
      switch (status) {
        case '1':
          return this.$t('mess.mess31')
          break;
        case '2':
          return this.$t('mess.mess32')
          break;
      }
    },
    replyStatusShow (status) {
      switch (status) {
        case '1':
          return this.$t('mess.mess34')
          break;
        default:
          return this.$t('mess.mess38')
          break;
      }
    },
    readStatusShow (status) {
      switch (status) {
        case '1':
          return this.$t('mess.mess10')
          break;
        default:
          return this.$t('mess.mess9')
          break;
      }
    },
    toOrderDetail (row) {
      this.$router.push({
        name: 'orderDetail',
        query: {
          id: row.orderId,
          isEdit: '0'
        }
      })
    }
  },
  watch: {
    //监听时间选择器绑定值变化
    dateRangeValue () {
      //解决时间选择器清空后 绑定值为null问题
      if (!this.dateRangeValue) {
        this.dateRangeValue = [];
        this.queryInfo.createTimeStart = '';
        this.queryInfo.createTimeEnd = '';
      } else {
        if (this.dateRangeValue.length > 0) {
          this.queryInfo.createTimeStart = this.dateRangeValue[0];
          this.queryInfo.createTimeEnd = this.dateRangeValue[1];
        }
      }

    }
  },
  created () {
    this.getStatisticalNum();
    this.getMessageList();
  }
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}
.title {
  font-weight: bold;
  font-size: 18px;
  text-align: left;
  margin: 15px 0;
}

.el-table .el-button--small {
  padding: 4px 10px;
}
/deep/ .breadcrumb-container {
  display: none;
}
</style>
